import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import List from './List';
import EditModel from './EditModel';
import NewModel from './NewModel';

class Container extends Component {
  render() {
    return (
      <div id="model">
        <Route exact path="/model" component={List} />
        <Route exact path="/model/new" component={NewModel} />
        <Route exact path="/model/:id/edit" component={EditModel} />
      </div>
    );
  }
}

export default Container;
